/* eslint-disable react/jsx-props-no-spreading */
import { useState } from 'react';
// mantine
import { Button, ButtonProps } from '@mantine/core';
import { useTimeout } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';
// utils
import type { IEventConnectorData } from '@newo/api/gateway';
import { useSendConnectorEventMutation } from '@/services/events/events.queries.ts';
import { useProjectsBatchPublishMutation } from '@/services/designer/projects/projects.queries.ts';

const SYNC_TIMEOUT = 10000;

const PublishAgentButton = (props: ButtonProps) => {
    const [isSyncDisabled, setIsSyncDisabled] = useState(false);
    const { mutate: sendConnectorEvent, isPending } =
        useSendConnectorEventMutation();
    const { start } = useTimeout(() => {
        setIsSyncDisabled(false);
    }, SYNC_TIMEOUT);

    const {
        mutateAsync: batchPublishProjects,
        isPending: isBatchPublishPending
    } = useProjectsBatchPublishMutation();

    const handlePublish = async () => {
        await batchPublishProjects();
        sendConnectorEvent(
            {
                integration_idn: 'api',
                connector_idn: 'environment',
                event_idn: 'start_update_event'
            } as IEventConnectorData,
            {
                onSuccess: () => {
                    notifications.show({
                        color: 'green',
                        message: 'Agent published successfully'
                    });
                }
            }
        );
        setIsSyncDisabled(true);
        start();
    };

    return (
        <Button
            {...props}
            disabled={isSyncDisabled}
            loaderProps={{ variant: 'dots' }}
            loading={isPending || isBatchPublishPending}
            size="xs"
            onClick={handlePublish}
        >
            Apply
        </Button>
    );
};

export default PublishAgentButton;
